import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

// 移除关注
export function getremovergz(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/shopping/collection',
    method: 'post',
    data
  })
}
// 询价购物车数据
export function getenquirycart(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/enquiryCart/getEnquiryCart',
    method: 'get',
    params
  })
}
// 删除询价购物车数据
export function getenquirycartdele(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/enquiryCart/deleteEnquiryCart',
    method: 'delete',
    data
  })
}
// 询价购物车的数量以及失效数量
export function getenquirycartnum(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/enquiryCart/getEnquiryCartNum',
    method: 'get',
    params
  })
}
// 询价购物车结算
export function tableListPostxj(params, data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/enquiryCart/enquiryOrderDetails',
    method: 'post',
    params,
    data
  })
}
export function getflush(params) {
  return axios.request({
    url: `${urlObj.wss}wss-order/shopping/refreshShoppingCart`,
    method: 'get',
    params
  })
}
// 购物车数据
export function findListShoppCars(params) {
  return axios.request({
    url: `${urlObj.wss}wss-order/shopping/carts`,
    method: 'get',
    params
  })
}

export function firstShopping() {
  return axios.request({
    url: `${urlObj.wss}wss-order/shopping/prepare/carts`,
    method: 'get'
  })
}

export function deleteShoppingCart(data, params) {
  return axios.request({
    url: `${urlObj.wss}wss-order/shopping/deleteShoppingCart`,
    method: 'post',
    params,
    data
  })
}

export function change(params, data) {
  return axios.request({
    url: `${urlObj.wss}wss-order/shopping/discount`,
    method: 'post',
    params,
    data
  })
}

//=====批量导入购物车=====

//通过店铺名称获取店铺数据
export function getShopListByName(params){
  return axios.request({
    url:`${urlObj.crm}crm/tenantManage/findByName`,
    method:'get',
    params
  })
}
//获取批量导入购物车模板
export function getTemplateOfShopping(){
  return axios.request({
    url:`${urlObj.wss}wss-order/shopping/cart/download/tpl`,
    method:'get',
  })
}
//批量导入购物车文件
export function submitImportShoppingCart(data){
  return axios.request({
    url:`${urlObj.wss}wss-order/shopping/cart/upload/shoppings`,
    method:'post'
  })
}
//获取批量导入结果
export function cartGetResult(params){
  return axios.request({
    url:`${urlObj.wss}wss-order/shopping/cart/getResult`,
    method:'get',
    params
  })
}
//导出导入结果
export function exportImpRes(params){
  return `${urlObj.wss}wss-order/shopping/cart/export`
}